import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import StudentSidebar from "../common/studentSidebar";
import ProfileCard from "../common/profileCard";
import ForumCard from "../common/forumCard";
import { useHandleForum } from "../../../core/hooks/useHandleForum";
import { Pagination } from "../../../core/common/ults/pagination";
import Skeleton from "react-loading-skeleton";

const StudentForums = () => {
  const { t } = useTranslation();
  const { allForums, isAllForumsLoading, refetchAllForums } = useHandleForum();

  useEffect(() => {
    refetchAllForums();
  }, [refetchAllForums]);

  const itemsPerPage = 4; // Số lượng courses hiển thị trên mỗi trang
  const [currentPage, setCurrentPage] = useState(1);

  // Tính toán dữ liệu hiển thị
  const startIndex = (currentPage - 1) * itemsPerPage;
  const forumsArray = Array.isArray(allForums) ? allForums.filter((forum: any) => forum.numdiscussions > 0) : [];
  const currentForums = forumsArray.slice(startIndex, startIndex + itemsPerPage);

  return (
    <>
      <div className="content">
        <div className="container">
          {/* profile box */}
          <ProfileCard />
          {/* profile box */}
          <div className="row">
            {/* sidebar */}
            <StudentSidebar />
            {/* sidebar */}
            <div className="col-lg-9">
              <Breadcrumb title={t("sidebarMenu.forum")} />
              <div className="page-title d-flex align-items-center justify-content-between">
                <h5>{t("sidebarMenu.forum")}</h5>
              </div>
              {isAllForumsLoading ? (
                <Skeleton height={130} className="mb-3" />
              ) : (
                <>
                  {currentForums.length > 0 ? (
                    currentForums.map((item: any, idx: any) => (
                      <ForumCard key={idx} forumData={item} />
                    ))
                  ) : (
                    <p>{t("student.forums.noForums")}</p>
                  )}
                </>
              )}
              {/* /pagination */}
              <Pagination
                totalItems={forumsArray.length}
                itemsPerPage={itemsPerPage}
                onPageChange={(page: number) => setCurrentPage(page)}
              />
              {/* /pagination */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentForums;
